import { useQuery } from 'react-query';

import { getEmptyPage, IPaging, IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getOccupancies } from 'modules/accommodations/features/reservations/api';

interface IProps extends IPaging, IQueryParameters {
  isEnabled: boolean;
}

export const useQueryOccupancies = ({ params, pageNo, pageSize, isEnabled }: IProps) => {
  const {
    data: occupancies,
    isError: isErrorOccupancies,
    isFetching: isFetchingOccupancies,
    refetch: refetchOccupancies,
    isLoading,
  } = useQuery(
    [QUERY_KEYS.UNITS_OCCUPANCIES, pageNo, params],
    () => getOccupancies({ params, pageSize, pageNo }),
    { enabled: isEnabled }, //5 minutes
  );

  return {
    occupancies: occupancies || getEmptyPage(),
    isErrorOccupancies,
    isFetchingOccupancies,
    refetchOccupancies,
    isLoading,
  };
};
